import type { BusError, ErrorCode } from './types.ts'

export function busError(
  code: ErrorCode,
  message: string,
  extra?: { hint?: string; path?: string; details?: unknown },
): BusError {
  const err: BusError = { code, message }
  if (extra?.hint !== undefined) err.hint = extra.hint
  if (extra?.path !== undefined) err.path = extra.path
  if (extra?.details !== undefined) err.details = extra.details
  return err
}

/**
 * 註冊等同步操作失敗時拋出的例外。
 * 非同步操作（write / call）不拋例外，一律回傳 { ok: false, error }。
 */
export class BusFault extends Error {
  readonly error: BusError

  constructor(error: BusError) {
    super(`[${error.code}] ${error.message}`)
    this.name = 'BusFault'
    this.error = error
  }
}

export function fault(
  code: ErrorCode,
  message: string,
  extra?: { hint?: string; path?: string; details?: unknown },
): BusFault {
  return new BusFault(busError(code, message, extra))
}
